<template>
  <div>
    <Page :selectedPageTemplate="templateName" />
  </div>
</template>

<script>
export default {
  components: {
    Page: () => import("@/components/Design/View/ViewTheme")
  },
  computed: {
    templateName() {
      return this.$route.params.id || "Basic Page";
    }
  },
  created() {
    // No need to load pages - custom templates are self-contained
  }
};
</script>
